var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.414,
    height: 21.4146,
    viewBox: "0 0 21.414 21.4146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        ", "\n         fill=\"current\"\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.4472,10.7911A10.16,10.16,0,0,0,4.2715,18.729L3,20l1.414,1.4146L5.9883,19.84a10.1068,10.1068,0,0,0,9.3818-.0557l1.63,1.63L18.414,20l-1.3447-1.3442A10.173,10.173,0,1,0,.4472,10.7911ZM10.622,2.6153a8.1758,8.1758,0,1,1-8.1748,8.1758A8.1839,8.1839,0,0,1,10.622,2.6153Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.0857,
    y: 1.2072,
    width: 4.2426,
    height: 2.0001,
    transform: "translate(-0.9144 2.2064) rotate(-44.9878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.2069,
    y: 0.086,
    width: 2.0001,
    height: 4.2426,
    transform: "translate(4.0648 14.2279) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.707 14.707 13.707 14.707 13.707 12.707 10.121 12.707 14.414 8.415 13.707 6.707 7.707 6.707 7.707 8.707 11.293 8.707 7 13 7.707 14.707"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/late.c0627b4bed3dd52327c50ab368783793.svg";
export { ForwardRef as ReactComponent };